import { requestHelpers } from '../../helpers';

export const postCVInterest = personId => {
    const endpoint = `/people/${personId}/interest`, interest_id = 3;

    requestHelpers
        .authenticatedPostRequest(endpoint, { interest_id })
        .then((response) => {
            console.log('api post interest', response.success)
        })
        .catch((error) => {
            console.log(`ERROR ${ error }`)
        })
}


// WEBPACK FOOTER //
// src/client/actions/cvservice/cvservice.js